var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCoffeIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0457 7.30617V6.13781C16.0457 5.16991 15.2475 4.38528 14.2629 4.38528H10.1029L10.7803 2.72037L13.3952 1.69222C13.8531 1.51316 14.0766 1.00314 13.8944 0.55307C13.7122 0.102998 13.1934 -0.1167 12.7355 0.0623608L9.76411 1.23072C9.53611 1.31979 9.35553 1.4973 9.26491 1.72143L8.18332 4.38528H3.56571C2.58107 4.38528 1.78286 5.16991 1.78286 6.13781V7.30617C0.798212 7.30617 0 8.0908 0 9.0587V11.3954C0 12.3633 0.798212 13.1479 1.78286 13.1479C1.77555 13.2393 1.77555 13.3311 1.78286 13.4225L3.56571 24.5219C3.70433 25.3813 4.46343 26.0106 5.34857 25.9999H12.48C13.3651 26.0106 14.1242 25.3813 14.2629 24.5219L16.0457 13.4225C16.053 13.3311 16.053 13.2393 16.0457 13.1479C17.0304 13.1479 17.8286 12.3633 17.8286 11.3954V9.0587C17.8286 8.0908 17.0304 7.30617 16.0457 7.30617ZM3.56648 6.13782H14.2636V7.30618H3.56648V6.13782ZM12.4808 24.2472H5.34933L3.56648 13.1478H14.2636L12.4808 24.2472ZM16.0464 11.3954H1.78351V9.05865H16.0464V11.3954Z",
    fill: "#D4D4D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeIconGray);
export default __webpack_public_path__ + "static/media/coffe_icon_gray.d0303e507a788ae421c1c37ab53bdb88.svg";
export { ForwardRef as ReactComponent };